import type { ReactNode } from 'react';

export const symbol_airline_seat_legroom_normal: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M660-410H320q-28.87 0-49.44-20.56Q250-451.13 250-480v-330q0-12.75 8.63-21.38Q267.25-840 280-840h160q12.75 0 21.38 8.62Q470-822.75 470-810v220h220q28.88 0 49.44 20.56T760-520v300h70q21 0 35.5 14.5T880-170q0 21-14.5 35.5T830-120H690q-12.75 0-21.37-8.63Q660-137.25 660-150v-260ZM530-280H180q-24.75 0-42.37-17.63Q120-315.25 120-340v-470q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v470h350q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5Z"
		/>
	</svg>
);
